module.exports = __webpack_public_path__ + "img/banhanguytin.ae56d0d3.png";